import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {compose} from 'shared/utils/compose';
import {useFutureDaysCount, useKeyboardInput} from 'ui/utils/core';

import {useDispatch} from 'ui/store';
import {closeSettings as closeSettingsAction} from 'store/UI';

import {RecalcSettings, AdapteeProps as RecalcProps} from 'ui/adapters/Core';
import {useAnalytics} from 'ui/adapters/Analytics';
import {Button} from 'components/Button';

export const SettingsMenu = (): ReactElement => {
  const closeSettings = useDispatch(closeSettingsAction);
  const registerEvent = useAnalytics(EventKind.CreateBudget);

  const input = useKeyboardInput();
  const days = useFutureDaysCount();
  const saveButtonDisabled = input <= 0 || days <= 0;

  return (
    <>
      <Button onPress={closeSettings}>Отменить</Button>
      <RecalcSettings>
        {({recalcSettings}: RecalcProps) => (
          <Button
            onPress={compose(recalcSettings, closeSettings, registerEvent)}
            disabled={saveButtonDisabled}
            color='yellow'
          >
            Сохранить
          </Button>
        )}
      </RecalcSettings>
    </>
  );
};
